import { z } from "zod";

const SCORE_RX = /^\s*__SCORE__\s*:\s*(\{[^\n]*\})\s*$/m;

export const RawScoreSchema = z.object({
  adequaatheid: z.coerce.number().int().min(0).max(3).default(0),
  woordenschat: z.coerce.number().int().min(0).max(2).default(0),
  grammatica: z.coerce.number().int().min(0).max(2).default(0),
  helderheid: z.coerce.number().int().min(0).max(1).default(0),
});

export type RawScore = z.infer<typeof RawScoreSchema>;

export interface TextScoreExtraction {
  score: { ad: number; wo: number; gr: number; helderheid: number } | null;
  cleaned: string;
}

export function extractScore(replyText: string): TextScoreExtraction {
  const match = replyText.match(SCORE_RX);
  if (!match) return { score: null, cleaned: replyText };
  const captured = match[1];
  if (!captured) return { score: null, cleaned: replyText.replace(SCORE_RX, "").trim() };
  let raw: RawScore;
  try {
    raw = RawScoreSchema.parse(JSON.parse(captured));
  } catch {
    return { score: null, cleaned: replyText.replace(SCORE_RX, "").trim() };
  }
  return {
    score: {
      ad: raw.adequaatheid,
      wo: raw.woordenschat,
      gr: raw.grammatica,
      helderheid: raw.helderheid,
    },
    cleaned: replyText.replace(SCORE_RX, "").trim(),
  };
}
